import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Checkboxes } from "../../../FlowConfigurationInputs";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
export default function DeleteMailbox({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.EWS.";
  const options = {
    checkboxes: { label: label + "PERMANENT" },
  };
  return (
    <div>
      <div className="form-element">
        {t(label + "USERNAME")}
        <TextInput
          action={action}
          inputName="userName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
        />
      </div>
      <div className="form-element">
        <Checkboxes
          action={action}
          inputName="permanent"
          options={options.checkboxes}
        />
      </div>
    </div>
  );
}

